import React from "react";

const NonQCLarge = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 48 48"
      style={style}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M36.5 18c0 6.904-5.596 12.5-12.5 12.5S11.5 24.904 11.5 18 17.096 5.5 24 5.5 36.5 11.096 36.5 18zm-6.048 12.428A13.94 13.94 0 0124 32a13.94 13.94 0 01-6.452-1.572v11.827c0 .19.211.31.383.218l5.196-2.766a1.865 1.865 0 011.746 0l5.196 2.766c.172.091.383-.029.383-.218V30.428zM32 29.491c3.627-2.53 6-6.733 6-11.491 0-7.732-6.268-14-14-14s-14 6.268-14 14c0 4.758 2.373 8.96 6 11.49v12.765c0 1.326 1.475 2.166 2.68 1.526l5.195-2.766a.266.266 0 01.25 0l5.196 2.766c1.204.64 2.679-.2 2.679-1.526V29.49z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17 19.96a.75.75 0 111.06-1.06l2.97 2.97a.3.3 0 00.425 0l8.627-8.627a.75.75 0 011.06 1.06l-9.192 9.193a1 1 0 01-1.414 0L17 19.96z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default NonQCLarge;
